import { waLink, WA_MESSAGES } from "@/utils/whatsapp";
import { WhatsAppIcon } from "@/components/Footer";

export const FloatingWhatsApp = () => (
  <a
    href={waLink(WA_MESSAGES.general)}
    target="_blank"
    rel="noopener noreferrer"
    aria-label="Chat with the hospital on WhatsApp"
    className="fixed bottom-5 right-5 z-40 flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] text-white shadow-xl transition-transform duration-200 hover:scale-110 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-emerald-700 focus-visible:ring-offset-2"
    data-testid="floating-whatsapp-button"
  >
    <WhatsAppIcon className="h-7 w-7" />
  </a>
);
